import React from "react";
import { Table, Row, Col } from "react-bootstrap";
import Thead from "./thead";
import Colgroup from "./colgroup";
import Tbody from "./tbody";
import Searcher from "./searcher";
import PageSizer from "./sizer";
import Pagination from "./pagination";

class FeraTable extends React.Component {
    get total() {
        if (this.props.total !== undefined && this.props.total !== null) {
            return Number(this.props.total) || 0;
        }
        return this.props.page?.length || 0;
    }

    get resultCaption() {
        const total = this.total;
        if (!total) return "Showing 0 results";
        const first = (Number(this.props.index || 0) * Number(this.props.size || total)) + 1;
        const last = Math.min(first + (this.props.page?.length || 0) - 1, total);
        return `Showing ${first} to ${last} of ${total} results`;
    }

    renderState = () => (
        <div className="licensee-data-table-empty" role={this.props.loading ? "status" : undefined}>
            <strong>{this.props.loading ? "Loading results..." : this.props.emptyTitle || "No results found"}</strong>
            {!this.props.loading && this.props.emptyDescription
                ? <span>{this.props.emptyDescription}</span>
                : null}
        </div>
    );

    renderTable = () => (
        <div className={this.props.variant === "licensee" ? "licensee-data-table-frame" : ""}>
            <Table
                className={this.props.className || (this.props.variant === "licensee" ? "licensee-data-table" : "react-table boxed")}
                role="table"
                aria-label={this.props.ariaLabel}
            >
                <Colgroup headers={this.props.headers} />
                <Thead headers={this.props.headers} onColumnClick={this.props.onColumnClick} sort={this.props.sort} />
                {this.props.variant === "licensee" && (this.props.loading || !this.props.page?.length) ? (
                    <tbody>
                        <tr>
                            <td colSpan={this.props.headers.length} className="licensee-data-table-empty">
                                {this.renderState()}
                            </td>
                        </tr>
                    </tbody>
                ) : this.props.page ? <Tbody headers={this.props.headers} page={this.props.page} /> : null}
            </Table>
        </div>
    );

    renderCards = () => {
        if (this.props.loading || !this.props.page?.length) return this.renderState();
        if (this.props.renderCards) return (
            <div className="licensee-data-card-grid">
                {this.props.renderCards(this.props.page)}
            </div>
        );
        return (
            <div className="licensee-data-card-grid">
                {this.props.page.map((item, index) => this.props.renderCard(item, index))}
            </div>
        );
    };

    renderLicenseeToolbar = () => {
        if (!this.props.searchable && !this.props.sizable && !this.props.filter) return null;
        return (
            <div className="licensee-data-table-toolbar">
                <div className="licensee-data-table-toolbar-main">
                    {this.props.filter || null}
                </div>
                {this.props.searchable ? (
                    <div className="licensee-data-table-search">
                        <div className="search-input-container w-100 bg-foreground">
                            <Searcher onChange={this.props.onSearch} search={this.props.search} />
                        </div>
                    </div>
                ) : null}
                {this.props.sizable ? (
                    <div>
                        <div className="d-inline-block">
                            <PageSizer onChange={this.props.onSize} size={this.props.size} />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    };

    renderLegacyToolbar = () => (
        <>
            {this.props.searchable || this.props.sizable ? (
                <Row className="mb-3 mt-3">
                    {this.props.searchable ? (
                        <Col sm="12" md="5" lg="3" xxl="2">
                            <div className="d-inline-block float-md-start me-1 mb-1 mb-md-0 search-input-container w-100 shadow bg-foreground">
                                <Searcher onChange={this.props.onSearch} search={this.props.search} />
                            </div>
                        </Col>
                    ) : null}
                    {this.props.sizable ? (
                        <Col sm="12" md="7" lg="9" xxl="10" className="text-end">
                            <div className="d-inline-block">
                                <PageSizer onChange={this.props.onSize} size={this.props.size} />
                            </div>
                        </Col>
                    ) : null}
                </Row>
            ) : null}
            {this.props.filter || null}
        </>
    );

    render() {
        const licensee = this.props.variant === "licensee";

        if (!licensee) {
            return (
                <>
                    {this.renderLegacyToolbar()}
                    <Row>
                        <Col xs="12">
                            <Table className={this.props.className || "react-table boxed"} role="table">
                                <Colgroup headers={this.props.headers} />
                                <Thead headers={this.props.headers} onColumnClick={this.props.onColumnClick} sort={this.props.sort} />
                                {this.props.page ? <Tbody headers={this.props.headers} page={this.props.page} /> : null}
                            </Table>
                        </Col>
                        <Col xs="12">
                            <Pagination index={this.props.index} count={this.props.pages} onChange={this.props.onPageChange} />
                        </Col>
                    </Row>
                </>
            );
        }

        return (
            <div className="licensee-data-table-shell">
                {this.renderLicenseeToolbar()}
                {this.props.view === "card" && (this.props.renderCard || this.props.renderCards)
                    ? this.renderCards()
                    : this.renderTable()}
                <footer className="licensee-data-table-footer">
                    <span>{this.resultCaption}</span>
                    <Pagination
                        compact
                        index={this.props.index}
                        count={this.props.pages}
                        onChange={this.props.onPageChange}
                    />
                </footer>
            </div>
        );
    }
}

export default FeraTable;
